import { createAction } from '@reduxjs/toolkit';

export const toastrUpdateIsShow = createAction('toastr/updateIsShow');
export const toastrUpdateMessage = createAction('toastr/updateMessage');
export const toastrUpdateType = createAction('toastr/updateType');
export const toastrShowSuccess = createAction('toastr/showSuccess');
export const toastrShowError = createAction('toastr/showError');
export const toastrShowInfo = createAction('toastr/showInfo');
